import {WB_CustomerRow, WB_EntityRow} from "../PA.Core/PAdbSchemaRows";
import {IHierarchyNodeProvider, INode, INodeLogicalKey} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {esWB_Customer} from "../PA.Core/PAdbSchema";
import {CustomerNodeProvider} from "./CustomerNodeProvider";
import * as _ from "lodash"

export class CustomerNode
    implements INode
{
    private custRow: WB_CustomerRow
    private custProvider: CustomerNodeProvider

    private _bUseLogicalKey: boolean
    private _logicalKey: INodeLogicalKey

    private bTypesLoaded: boolean
    private dctEntity: {[wbEntityId: number]: WB_EntityRow}
    private dctEntityBySA: {[wbEntityId: number]: {[wbSalesAreaId: number]: WB_EntityRow}}



    constructor(custRow: WB_CustomerRow, provider: CustomerNodeProvider) {
        this.custRow = custRow
        this.custProvider = provider

        this.bTypesLoaded = false
        this.dctEntity = {}
        this.dctEntityBySA = {}

        this._bUseLogicalKey = (custRow.cif.HIER_NODE_IND == '1')
        this._logicalKey = {}
        _.forEach(custRow.WB_CustomerLogicalKeyRows, (a) => {
            if(!a.isActive)
                return
            let eLK: typeof this._logicalKey.a = {
                keyId: a.cif.KEY_ID,
                dataType: a.cif.DATATYPE
            }
            switch (eLK.dataType){
                case "entity":
                    eLK.valueWbId = a.cif.VALUE_WB_ID
                    eLK.valueWbEntityId = a.cif.VALUE_WB_ENTITY_ID
                    break
                case "number":
                    eLK.valueNumber = a.cif.VALUE_NUMBER
                    if(a.cif.VALUE_WB_ATTRIBUTEM_ID > 0)
                        eLK.valueWbAttributeMId  = a.cif.VALUE_WB_ATTRIBUTEM_ID
                    break
                case "string":
                    eLK.valueString = a.cif.VALUE_STRING
                    if(a.cif.VALUE_WB_ATTRIBUTEM_ID > 0)
                        eLK.valueWbAttributeMId  = a.cif.VALUE_WB_ATTRIBUTEM_ID
                    break
            }
            this._logicalKey[eLK.keyId] = eLK
        })


    }

    // Key
    get wbId(): number { return this.custRow.cif.WB_CUST_ID }
    get provider(): IHierarchyNodeProvider { return this.custProvider }

    // Logical Identity
    get id_ui(): string { return this.custRow.cif.CUSTOMER_ID }
    get key_set(): string { return this.custRow.cif.CUSTOMER_SET_ID }

    get bUseLogicalKey(): boolean {
        return this._bUseLogicalKey
    }
    get logicalKey(): INodeLogicalKey {
        return this._logicalKey
    }

    // Storage, needed to determine
    get mapperName(): string { return esWB_Customer }

    // Other properties
    get node_name(): string { return this.custRow.cif.CUSTOMER_NAME }


    isEntityType(wbEntityId: number, opts?: { wbSalesAreaIds?: number[] }): boolean {
        this.checkTypesLoaded()

        if(_.isEmpty(opts?.wbSalesAreaIds))
            return (wbEntityId in this.dctEntity)

        let subDct = this.dctEntityBySA[wbEntityId] || {}

        for(let wbSalesAreaId of opts.wbSalesAreaIds){
            if(wbSalesAreaId in subDct)
                return true
        }

        return false;
    }

    get entityTypes(): WB_EntityRow[] {
        this.checkTypesLoaded()

        return _.values(this.dctEntity)
    }


    private checkTypesLoaded(){
        if(this.bTypesLoaded)
            return

        // Use provider to create Dictionaries
        let dct = _.keyBy(this.provider.entityTypes, (a) => a.cif.META_WB_ID)
        _.forEach(this.custRow.WB_CustomerRoleRelationshipRows, (a) => {
            if(_.isEmpty(a.WB_CustomerRoleRow))
                return
            let wbSalesAreaId = a.cif.WB_SALESAREA_ID
            if(a.WB_CustomerRoleRow.cif.WB_CUSTM_ID in dct){
                let entityType = dct[a.WB_CustomerRoleRow.cif.WB_CUSTM_ID]
                let wbEntityId = entityType.cif.WB_ENTITY_ID

                if(!(wbEntityId in this.dctEntity))
                    this.dctEntity[wbEntityId] = entityType

                if(!(wbEntityId in this.dctEntityBySA))
                    this.dctEntityBySA[wbEntityId] = {}

                if(!(wbSalesAreaId in this.dctEntityBySA[wbEntityId]))
                    this.dctEntityBySA[wbEntityId][wbSalesAreaId] = entityType
            }
        })

        this.bTypesLoaded = true

    }



}